import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KonamiService {
  private konamiCode = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight'];
  private currentSequence: string[] = [];
  private isListening = false;
  
  private _konamiTriggered = new BehaviorSubject<boolean>(false);
  public konamiTriggered$ = this._konamiTriggered.asObservable();

 public serviceSelected = "";

  constructor() {
    this.startListening();
  }

  private startListening(): void {
    if (this.isListening) return;
    
    this.isListening = true;
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  private handleKeyDown(event: KeyboardEvent): void {
    // Add the key to the current sequence
    this.currentSequence.push(event.code);

    console.log(this.currentSequence);
    
    // Keep only the last 8 keys
    if (this.currentSequence.length > this.konamiCode.length) {
      this.currentSequence.shift();
    }
    
    // Check if the sequence matches the Konami code
    if (this.currentSequence.length === this.konamiCode.length) {
      const matches = this.currentSequence.every((key, index) => key === this.konamiCode[index]);
      
      if (matches) {
        this.triggerKonami();
        this.resetSequence();
      }
    }
  }

  private triggerKonami(): void {
    this._konamiTriggered.next(true);
  }

  private resetSequence(): void {
    this.currentSequence = [];
  }

  public resetKonami(): void {
    this._konamiTriggered.next(false);
  }

  public stopListening(): void {
    if (!this.isListening) return;
    
    this.isListening = false;
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }
}
